import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty';


export const OPT_SETTING_LOADING = "OPT_SETTING_LOADING";
export const OPT_SETTING_SUCCESS = "OPT_SETTING_SUCCESS";
export const OPT_SETTING_FAILED = "OPT_SETTING_FAILED";
export const EDIT_OPT_SETTING_SUCCESS = "EDIT_OPT_SETTING_SUCCESS";


export const fetchOptSetting = () => {
    return (dispatch: Dispatch<any>) => {
        let URL = '';
        dispatch({ type: OPT_SETTING_LOADING, payload: {} });

        URL = `/opt/settings`;


        networkCall("get", URL, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    dispatch({ type: OPT_SETTING_SUCCESS, payload: { res: res.data } });

                } else {
                    dispatch({ type: OPT_SETTING_FAILED, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: OPT_SETTING_FAILED, payload: { error: error.response.data } });
                }
            });
    }
}




export const updateSettings = (data: any, cb: (message: string) => void) => {

    let URL = `/opt/settings`;
    let endPoint = apiBaseUrl.baseUrl;

    return (dispatch: Dispatch<any>) => {
        dispatch({ type: OPT_SETTING_LOADING, payload: {} });
        networkCall("put", URL, endPoint, true, true, data).then((res: any) => {
            if (res.error && isEmpty(res.error)) {
                dispatch({ type: EDIT_OPT_SETTING_SUCCESS, payload: { res: res.data } });
                cb(res.message);
            } else {
                dispatch({ type: OPT_SETTING_FAILED, payload: { error: res } });
            }
        }).catch((error) => {
            if (error?.response?.data) {
                dispatch({ type: OPT_SETTING_FAILED, payload: { error: error.response.data } });
            }
        });
    };
}
